import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectGenderState } from '../selectors';

export const getData = createSelector(selectGenderState, (state: State) => state.data);

export const getError = createSelector(selectGenderState, (state: State) => state.error);

export const getLoading = createSelector(selectGenderState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectGenderState, (state: State) => fn(state.data));
